import type { InputHTMLAttributes } from 'react';
import { pickCss } from '@/shared/lib/css-utils';
import css from './checkbox.module.scss';

const styles = pickCss(css, css.root);

type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label?: string;
};

export const Checkbox = ({
  label,
  className,
  checked,
  ...restProps
}: CheckboxProps) => (
  <label className={styles({ isChecked: !!checked }, className)}>
    <input
      checked={checked}
      className={css.input}
      type="checkbox"
      {...restProps}
    />
    {label && <span className={css.label}>{label}</span>}
  </label>
);
